<proffeo-ui-dialog
  [title]="
    mode === 'edit'
      ? ('project-tags.modals.edit-modal-title' | translate)
      : ('project-tags.modals.create-modal-title' | translate)
  "
>
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex flex-col w-full gap-4">
      <proffeo-ui-input
        [formField]="form.name"
        label="project-tags.modals.form-label-name"
      />

      <proffeo-ui-input
        [formField]="form.description"
        label="project-tags.modals.form-label-description"
      >
        <p proffeoUiInputError>{{ 'ui-forms-the-maximum-value-is' | translate }} {{ descriptionMaxLength }}</p>
      </proffeo-ui-input>

      <proffeo-ui-color-picker
        [formField]="form.hexColor"
        label="project-tags.modals.form-label-color"
        class="w-full"
      />
      @if (previewTag(); as tag) {
        <div class="flex w-full items-center gap-2">
          <p class="pl-1 text-sm">{{ 'project-tags.modals.preview' | translate }}:</p>
          <proffeo-tag [tag]="tag"></proffeo-tag>
        </div>
      }
    </div>
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="form().invalid() || form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
